import { render } from "./SiderMenu.vue?vue&type=template&id=725a16b4"
import script from "./SiderMenu.vue?vue&type=script&lang=js"
export * from "./SiderMenu.vue?vue&type=script&lang=js"

import "./SiderMenu.vue?vue&type=style&index=0&id=725a16b4&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__